import {initialState as privacyPolicy} from '../components/privacy-policy/state';

export default {
  privacyPolicy
};
